import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, Fragment } from 'react';

import { DashboardsBackOffice } from "../../../components/backgrounds/DashboardsBackoffice";
import { HttpRequest } from '../../../services/httpRequest';
import { SuccessAlert } from '../../../components/alerts/successAlert';
import { ErrorAlert } from '../../../components/alerts/errorAlert';
import { roleUser } from '../../../utils/roleUser';
import { APIClient } from '../../../helpers/api_helper';
import * as urlHelper from '../../../helpers/url_helper';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { EditInteresMoratorioDialog } from '../../../components/dialogs/editInteresMoratorioDialog';
import { CreateInteresMoratorioDialog } from '../../../components/dialogs/CreateInteresMoratorioDialog';

const apiClient = new APIClient();

export function InteresMoratorioConfig(params) {
    const navigate = useNavigate();
    const [messsageAlert, setMessageAlert] = useState("");
    const [isOpenSuccess, setIsOpenSuccess] = useState();
    const [isOpenError, setIsOpenError] = useState();
    const [viewalert, setViewalert] = useState(false);
    const [formData, setFormData] = useState({
        interesUsuraTea: "",
        year: "",
        month: "",
    });
    const [latePaymentInterestToEdit, setLatePaymentInterestToEdit] = useState({
        _id: "",
        interesUsuraTea: "",
        year: "",
        month: "",
    });
    const [listLatepaymentInterest, setListLatepaymentInterest] = useState([]);
    const [viewModalEdit, setViewModalEdit] = useState(false);
    const [viewModalCreate, setViewModalCreate] = useState(false);
    const [refressListLatepaymentInterest, setRefreshsListLatepaymentInterest] = useState(false);

    const getInfoRole = async (doc) => {
        try {
            let response = await HttpRequest.getInfoRole(doc);
            return response.message;
        } catch (error) {
            console.log(error);
            return {}
        }
    }

    const getLatePaymentInterest = async () => {
        try {
            let response = await apiClient.get(urlHelper.GET_LATE_PAYMENT_INTEREST);
            return response.data?.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const handleClearStateAlert = () => {
        setViewalert(false);
        setMessageAlert("");
        setIsOpenSuccess(false);
        setIsOpenError(false);
    }

    const updatelatePaymentInterest = async () => {
        handleClearStateAlert();
        try {
            let payload = {
                interesUsuraTea: latePaymentInterestToEdit.interesUsuraTea,
                year: Number(latePaymentInterestToEdit.year),
                month: Number(latePaymentInterestToEdit.month)
            };
            let response = await apiClient.put(urlHelper.UPDATE_LATE_PAYMENT_INTEREST + "/" + latePaymentInterestToEdit._id, payload);
            let status = response.status;
            if (status === 200) {
                handleOpenAlert('success', response.data?.message, true);
            } else {
                handleOpenAlert('error', response.data?.message, true);
            }
            return response;
        } catch (error) {
            console.log(error);
            return [];
        }finally {
            setLatePaymentInterestToEdit({
                _id: "",
                interesUsuraTea: "",
                year: "",
                month: ""
            });
            setRefreshsListLatepaymentInterest(!refressListLatepaymentInterest);
            setTimeout(() => {
                handleClearStateAlert()
            }, 6000);
        }
    };

    const handlecreateLatePaymentInterest = async () => {
        handleClearStateAlert();
        try {
            let payload = {
                interesUsuraTea: formData.interesUsuraTea,
                year: Number(formData.year),
                month: Number(formData.month)
            };
            let response = await apiClient.create(urlHelper.CREATE_LATE_PAYMENT_INTEREST, {payload});
            let status = response.status;
            if (status === 200) {
                handleOpenAlert('success', response.data?.message, true);
            } else {
                handleOpenAlert('error', response.data?.message, true);
            }
            return response;
        } catch (error) {
            console.log(error);
            handleOpenAlert('error', 'Ha ocurrido un error inesperado, por favor intenta más tarde.', true);
            return [];
        }finally {
            setFormData({
                interesUsuraTea: "",
                year: "",
                month: ""
            });
            setRefreshsListLatepaymentInterest(!refressListLatepaymentInterest);
            setTimeout(() => {
                handleClearStateAlert()
            }, 6000);
        }
    }

    const handleOpenAlert = (type, message, isOpen) => {
        if (type === 'success') {
            setMessageAlert(message);
            setIsOpenSuccess(isOpen);
            setViewalert(true);
        }
        if (type === 'error') {
            setMessageAlert(message);
            setIsOpenError(isOpen);
            setViewalert(true);
        }
    }

    const handleClickEdit = (id) => {
        let latePaymentInterestToEdit = listLatepaymentInterest.find(latePaymentInterest => latePaymentInterest._id === id);
        setLatePaymentInterestToEdit({
            _id: latePaymentInterestToEdit._id,
            interesUsuraTea: latePaymentInterestToEdit.interesUsuraTea,
            year: latePaymentInterestToEdit.year,
            month: latePaymentInterestToEdit.month
        });
        handleOpenModalEdit();
    }

    const handleClickCreate = () => {
        handleOpenModalCreate();
    }

    const handleOpenModalEdit = () => {
        setViewModalEdit(true);
    }

    const handleCloseModalEdit = () => {
        setViewModalEdit(false);
    }

    const handleOpenModalCreate = () => {
        setViewModalCreate(true);
    }

    const handleCloseModalCreate = () => {
        setViewModalCreate(false);
    }

    useEffect(() => {
        let doc = localStorage.getItem('doc');
        if (typeof doc !== 'string') {
            return navigate('/ingresar');
        } else {
            getInfoRole(doc)
                .then(async (infoRole) => {
                    if (infoRole?.error === true) return navigate('/ingresar');
                    if ('user' in infoRole) {
                        let user = infoRole.user;

                        if (user?.roleUser === roleUser.admin) {
                            console.log('User authorized...');
                            let latePaymentInterests = await getLatePaymentInterest();
                            setListLatepaymentInterest(latePaymentInterests ?? []);
                        } else {
                            alert('No esta autorizado para ver esta página.');
                            setTimeout(() => {
                                return navigate('/ingresar');
                            }, 2000);
                        }
                    } else {
                        return navigate('/ingresar');
                    }
                })
                .catch(e => console.log(e))
        }
    }, [refressListLatepaymentInterest])

    return (
        <Fragment>
            {
                viewalert ?
                    <>
                        <SuccessAlert isOpen={isOpenSuccess} message={messsageAlert}></SuccessAlert>
                        <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
                    </>
                    : <></>
            }

            {viewModalEdit && <EditInteresMoratorioDialog
                handleCloseModalEdit={handleCloseModalEdit}
                latePaymentInterestToEdit={latePaymentInterestToEdit}
                setLatePaymentInterestToEdit={setLatePaymentInterestToEdit}
                dialogOpen={viewModalEdit}
                setDialogOpen={setViewModalEdit}
                updatelatePaymentInterest={updatelatePaymentInterest}
            />}

            {viewModalCreate && <CreateInteresMoratorioDialog
                handleCloseModalCreate={handleCloseModalCreate}
                dialogOpen={viewModalCreate}
                setDialogOpen={setViewModalCreate}
                formData={formData}
                setFormData={setFormData}
                handlecreateLatePaymentInterest={handlecreateLatePaymentInterest}
            />}

            <DashboardsBackOffice
                name={'Admin'}
                balance={0}
                current11={true}
                title={'Interes Moratorio'}
                main={
                    <>
                        <div className='flex flex-col'>
                            <div className='overflow-x-auto sm:-mx-6 lg:-mx-8'>
                                <div className='inline-block min-w-full py-2 sm:px-6 lg:px-8'>
                                    <div className='flex justify-end py-2 px-1'>
                                        <button
                                            onClick={handleClickCreate}
                                            type="button"
                                            className="flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-md font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
                                        >
                                            <div className="flex">
                                                {'Agregar'}
                                                <div className="grid content-center pl-2">{ }</div>
                                            </div>
                                        </button>
                                    </div>
                                    <div className='overflow-y-auto' style={{ height: '440px' }}>

                                        <table className='min-w-full text-left text-sm font-light text-surface dark:text-white bg-white'>
                                            <thead className='border-b border-neutral-200 font-medium dark:border-white/10'>
                                                <tr className='bg-tdark text-white'>
                                                    <th scope='col' className='px-6 py-4'>Id</th>
                                                    <th scope='col' className='px-6 py-4'>Interes usura TEA</th>
                                                    <th scope='col' className='px-6 py-4'>Año</th>
                                                    <th scope='col' className='px-6 py-4'>Mes</th>
                                                    <th scope='col' className='px-6 py-4'>Acciones</th>
                                                </tr>
                                            </thead>
                                            <tbody className='px-2 py-2'>
                                                {listLatepaymentInterest.map((latePaymentInterest, index) => (
                                                    <tr key={index} className='border-b border-neutral-200 transition duration-300 ease-in-out hover:bg-neutral-100 dark:border-white/10 dark:hover:bg-neutral-600'>
                                                        <td className='whitespace-nowrap px-6 py-4 font-medium'>{latePaymentInterest._id}</td>
                                                        <td className='whitespace-nowrap px-6 py-4'>{latePaymentInterest.interesUsuraTea}</td>
                                                        <td className='whitespace-nowrap px-6 py-4'>{latePaymentInterest.year}</td>
                                                        <td className='whitespace-nowrap px-6 py-4'>{latePaymentInterest.month}</td>
                                                        <td>
                                                            <div className='flex justify-center'>
                                                                <IconButton aria-label="editar" onClick={() => handleClickEdit(latePaymentInterest._id)}>
                                                                    <EditIcon />
                                                                </IconButton>
                                                            </div>

                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </>
                }
            />

        </Fragment>
    );
}